import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

function useDndKitItem({
  id,
  sortableProps
}) {
  const {
    transition,
    transform,
    isDragging,
    attributes: a11yAttributes,
    ...sortableResult
  } = useSortable({
    id,
    ...sortableProps
  });
  return {
    ...sortableResult,
    a11yAttributes,
    transition,
    transform,
    isDragging,
    style: {
      transition,
      position: "relative",
      // zIndex가 적용되게 하기 위해
      zIndex: isDragging ? 1 : "unset",
      transform: transform ? CSS.Transform.toString({
        x: transform.x,
        y: transform.y,
        /**
         * dnd-kit의 scale 값 조정(아래 링크 참조) 때문에 element rect가 서로 다른 item간의 reorder 이 일어나는 중간에 scale이 부자연스럽게 늘어나거나 줄어드는 현상이 있음.
         * 아마 dnd-kit 내부에서 가정하는 원본 데이터 변경 시점이 있는 것 같은데 그걸 아직 파악하지 못함.
         * 때문에 우선 scale 값은 항상 1로 들어가도록 한다.
         *
         * https://github.com/clauderic/dnd-kit/blob/master/packages/sortable/src/hooks/utilities/useDerivedTransform.ts#L34
         */
        scaleX: 1,
        scaleY: 1
      }) : void 0
    }
  };
}

export { useDndKitItem as default };
//# sourceMappingURL=useDndKitItem.mjs.map
